import { random } from 'lodash';

const TINT = {
    CRIT: 0xe67e22,
    ENRAGE_HIT: 0xe74c3c,
    AURA: 0x87CEEB
};

export default class Entry extends Phaser.GameObjects.Container {
    private sprite!: Phaser.GameObjects.Sprite;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupSprite();
    }

    setupSprite() {
        this.sprite = this.scene.add.sprite(0, 0, 'atlas', 'blank');
        this.add(this.sprite);
    }

    launch(x: number, y: number, isCrit: boolean, isEnrageHit: boolean, isAura: boolean = false) {
        if (isCrit) this.sprite.setTint(TINT.CRIT);
        if (isEnrageHit) this.sprite.setTint(TINT.ENRAGE_HIT);

        this.x = x;
        this.y = y;

        this.angle = random(360);

        this.sprite.play('vfx_hit');
        this.sprite.once('animationcomplete', () => this.emit('done', this));
    }

    activate() {
        this.setVisible(true);
        this.setActive(true);
        this.sprite.clearTint();
    }

    deactivate() {
        this.setVisible(false);
        this.setActive(false);
    }
}
